;("use strict")

function nodeScriptReplace(node) {
  if (nodeScriptIs(node) === true) {
    node.parentNode.replaceChild(nodeScriptClone(node), node)
  } else {
    var i = -1,
      children = node.childNodes
    while (++i < children.length) {
      nodeScriptReplace(children[i])
    }
  }

  return node
}
function nodeScriptClone(node) {
  var script = document.createElement("script")
  script.text = node.innerHTML

  var i = -1,
    attrs = node.attributes,
    attr
  while (++i < attrs.length) {
    script.setAttribute((attr = attrs[i]).name, attr.value)
  }
  return script
}

function nodeScriptIs(node) {
  return node.tagName === "SCRIPT"
}
var Ajaxinate = function (e) {
  var i = e || {},
    n = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    }
  ;(this.settings = Object.assign(n, i)),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    (this.disableInfiniteScroll = false),
    this.initialize()
}
;(Ajaxinate.prototype.initialize = async function () {
  try {
    let shouldClearCache = false
    let pagesToRender = []
    const parser = new DOMParser()

    const pushProperPageToGrid = async function (pagination, cachedPages) {
      await Promise.all(
        cachedPages?.map(async (newCache) => {
          const date = new Date(newCache.headers.get("date"))
          if (Date.now() > date.getTime() + 1000 * 60 * 5) {
            shouldClearCache = true
            return
          }

          if (pagination.href === newCache?.url) {
            const newHtml = await newCache?.text()
            const newReturnedHTML = await parser?.parseFromString(
              newHtml,
              "text/html"
            )
            const newElements = newReturnedHTML?.querySelector("#product-grid")
            pagesToRender?.push(newElements)

            const newPagination = newReturnedHTML
              .querySelector("#pagination-link")
              ?.querySelector("a")

            if (newPagination?.href) {
              await pushProperPageToGrid(newPagination, cachedPages)
            } else {
              document.querySelector("#pagination-link").innerHTML = null
              return
            }
          } else {
            document.querySelector("#pagination-link").href = pagination?.href
          }
        })
      )
    }

    if (this.containerElement) {
      const allCaches = await caches?.open("collection-products-cache")
      const cachedPages = await allCaches?.matchAll(window.location.href, {
        ignoreSearch: true,
      })
      const firstLink = document
        .querySelector("#pagination-link")
        .querySelector("a")

      if (firstLink) {
        await pushProperPageToGrid(firstLink, cachedPages)
      }

      await allCaches?.delete(window.location.href, {
        ignoreSearch: true,
      })

      if (shouldClearCache) {
        await allCaches?.delete(window.location.href, {
          ignoreSearch: true,
        })
        nodeScriptReplace(container)
      } else {
        const container = document.querySelector("#product-grid")
        pagesToRender?.forEach((page) => {
          container?.insertAdjacentHTML("beforeend", page?.innerHTML)
        })
        nodeScriptReplace(container)
      }
      var e = { click: this.addClickListener, scroll: this.addScrollListeners }
      e[this.settings.method]()
    }
  } catch (error) {
    // console.log(error, "No cache")
    var e = { click: this.addClickListener, scroll: this.addScrollListeners }
    e[this.settings.method]()
  }
}),
  (Ajaxinate.prototype.addScrollListeners = async function () {
    let cachedPages = 0
    const allCaches = await caches?.open("collection-products-cache")
    cachedPages = await allCaches.matchAll(window.location.href, {
      ignoreSearch: true,
    })
    this.paginationElement &&
      (document.addEventListener("scroll", this.checkIfPaginationInView),
      window.addEventListener("resize", this.checkIfPaginationInView),
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      ))
  }),
  (Ajaxinate.prototype.addClickListener = function () {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      (this.clickActive = !0),
      this.nextPageLinkElement !== null &&
        this.nextPageLinkElement.addEventListener(
          "click",
          this.stopMultipleClicks
        ))
  }),
  (Ajaxinate.prototype.stopMultipleClicks = function (e) {
    e.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        this.loadMore())
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = async function () {
    var e =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset,
      i =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset
    e <= window.innerHeight &&
      i >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()))
  }),
  (Ajaxinate.prototype.loadMore = function () {
    ;(this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = async function () {
        if (this.request.readyState === 4 && this.request.status === 200) {
          var i = this.request.responseXML.querySelectorAll(
              this.settings.container
            )[0],
            n = this.request.responseXML.querySelectorAll(
              this.settings.pagination
            )[0]
          this.containerElement.insertAdjacentHTML("beforeend", i.innerHTML),
            (this.paginationElement.innerHTML = n.innerHTML),
            this.settings.callback &&
              typeof this.settings.callback == "function" &&
              this.settings.callback(this.request.responseXML),
            await this.initialize()
        }
      }.bind(this)),
      this.request.open("GET", this.nextPageUrl),
      (this.request.responseType = "document"),
      this.request.send()
    // caches.open("collection-products-cache").then((cache) => {
    //   cache.add(this.nextPageUrl)
    // })
  }),
  (Ajaxinate.prototype.removeClickListener = function () {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
  }),
  (Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
      window.removeEventListener("resize", this.checkIfPaginationInView),
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      )
  }),
  (Ajaxinate.prototype.destroy = function () {
    var e = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    }
    return e[this.settings.method](), this
  })

document.addEventListener("DOMContentLoaded", function () {
  let endlessScroll = null
  if (!endlessScroll) {
    endlessScroll = new Ajaxinate({
      container: "#product-grid",
      pagination: "#pagination-link",
      loadingText:
        '<div style="color: black;" class="loader"><span></span></div>',
      offset: 500,
    })

    let previousUrl = ""
    const observer = new MutationObserver(function (mutations) {
      if (window.location.href !== previousUrl && !endlessScroll) {
        previousUrl = window.location.href

        endlessScroll = new Ajaxinate({
          container: "#product-grid",
          pagination: "#pagination-link",
          loadingText: '<div class="loader"><span></span></div>',
          offset: 500,
        })
      }
    })

    const config = { subtree: true, childList: true }
    observer.observe(document, config)
  }
})
